export default {
  get() {
    var sessionKeyString = sessionStorage.getItem("sessionKey")
    try {
      var sessionKey = JSON.parse(sessionKeyString)
      return sessionKey
    } catch (err) {
      return null
    }
  },
  set: (sessionKey) => {
    sessionStorage.setItem("sessionKey", JSON.stringify(sessionKey))
  },
  remove: () => {
    sessionStorage.removeItem("sessionKey")
  },
}
